/* eslint-disable jsdoc/require-example */
import {UAParserService} from 'Services/UAParserService';

/**
 * @description Check the os and display specific item.
 */
export default class AppMobileDisplay {
    /**
     * @description DomElement with data-attribute to display for each os.
     * @param  {HTMLElement} domElement - Dom item with the attribute.
     */
    constructor(domElement) {
        this.domElement = domElement;
        this.osSelector = {
            android: '[data-app-android]',
            ios: '[data-app-ios]'
        };
        this.hideClass = 'hidden';
        this.currentOS = UAParserService.getOS();

        this.initDisplay(this.currentOS);
    }

    /**
     * @description Check the name of the os and selecto the desplay.
     * @type {object}
     * @param {string} name - Name the the os.
     */
    initDisplay({name}) {
        if(!name) {
            this.allDisplay();
            return;
        }

        const target = this.osSelector[name.toLowerCase()];

        if(target) {
            this.domElement
                .querySelector(target)
                .classList
                .remove(this.hideClass);
        } else {
            this.allDisplay();
        }
    }

    /**
     * @description Display all the element if os android or ios.
     */
    allDisplay() {
        Object
            .keys(this.osSelector)
            .forEach(operatingSystem => {
                this.domElement
                    .querySelector(this.osSelector[operatingSystem])
                    .classList
                    .remove(this.hideClass);
            });
    }
}
